import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=65665ac1&scoped=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"
import style0 from "./modal.vue?vue&type=style&index=0&id=65665ac1&prod&lang=less&scoped=true"
import style1 from "./modal.vue?vue&type=style&index=1&id=65665ac1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65665ac1",
  null
  
)

export default component.exports